import { render, staticRenderFns } from "./content-registry-grid.vue?vue&type=template&id=1b285090&scoped=true&"
import script from "./content-registry-grid.ts?vue&type=script&lang=ts&"
export * from "./content-registry-grid.ts?vue&type=script&lang=ts&"
import style0 from "./content-registry-grid.scss?vue&type=style&index=0&id=1b285090&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b285090",
  null
  
)

export default component.exports